import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { decode as base64_decode } from 'base-64';

const ModalCartaAberta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Verificar se já foi exibido
    const jaExibido = localStorage.getItem('modalCartaAberta2024');
    if (jaExibido === 'true') {
      return;
    }

    // Verificar plano do usuário
    const storage_ = sessionStorage.getItem('ddesp');
    if (storage_) {
      const usersRt = JSON.parse(base64_decode(storage_));
      const plano = usersRt[8]; // índice 8 contém o plano
      
      // Não exibir para plano 5
      if (plano === '5') {
        return;
      }
    }

    // Verificar se está no período válido (23/12/2025 até 04/01/2026)
    const hoje = new Date();
    const dataInicio = new Date('2025-12-23');
    const dataFim = new Date('2026-01-04T23:59:59');

    if (hoje >= dataInicio && hoje <= dataFim) {
      // Pequeno delay para não aparecer imediatamente
      setTimeout(() => {
        setShow(true);
      }, 1500);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem('modalCartaAberta2024', 'true');
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      size="lg"
      backdrop="static"
      className="modal-carta-aberta"
    >
      <style>
        {`
          .modal-carta-aberta .modal-content {
            border: none;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          }
          .modal-carta-aberta .modal-header {
            background: linear-gradient(135deg, #4099ff 0%, #2d7dd2 100%);
            border: none;
            padding: 25px 30px;
          }
          .modal-carta-aberta .modal-title {
            font-size: 22px;
            font-weight: 600;
            letter-spacing: 0.3px;
          }
          .carta-header-icon {
            display: inline-block;
            animation: pulse 2s infinite;
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
          .carta-body-container {
            background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
          }
          .carta-icon-top {
            background: #4099ff;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 25px;
            box-shadow: 0 5px 15px rgba(64, 153, 255, 0.3);
          }
          .carta-texto {
            background: white;
            padding: 30px;
            border-radius: 10px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            line-height: 1.9;
            font-size: 15.5px;
            color: #2c3e50;
          }
          .carta-assinatura {
            background: linear-gradient(135deg, #4099ff 0%, #2d7dd2 100%);
            padding: 25px;
            border-radius: 10px;
            margin-top: 25px;
          }
          .carta-footer-custom {
            background: #f8f9fa;
            border-top: 2px solid #e9ecef;
            padding: 20px 30px;
          }
          .btn-entendido {
            padding: 12px 40px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 8px;
            transition: all 0.3s ease;
          }
          .btn-entendido:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(64, 153, 255, 0.3);
          }
          .decorative-line {
            width: 60px;
            height: 3px;
            background: #4099ff;
            margin: 0 auto 20px;
            border-radius: 2px;
          }
        `}
      </style>
      <Modal.Header closeButton className="text-white border-0">
        <Modal.Title>
          <span className="carta-header-icon">
            <i className="mdi mdi-heart mr-2"></i>
          </span>
          Uma Mensagem Especial para Você
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="carta-body-container p-4">
        <div className="text-center mb-4">
          <div className="carta-icon-top">
            <i className="mdi mdi-heart text-white" style={{ fontSize: '40px' }}></i>
          </div>
          <div className="decorative-line"></div>
        </div>
        
        <div className="carta-texto">
          <p className="mb-4" style={{ fontSize: '17px' }}>
            <strong style={{ color: '#4099ff' }}>Queridos clientes e parceiros,</strong>
          </p>
          
          <p className="mb-3 text-justify">
            Ao final de mais um ano repleto de desafios e conquistas, queremos dedicar este momento para expressar 
            nossa profunda gratidão a cada um de vocês que fazem parte da jornada do Espião Cloud.
          </p>
          
          <p className="mb-3 text-justify">
            Vocês são a razão pela qual nos dedicamos incansavelmente para entregar não apenas um sistema, mas uma 
            solução que realmente faça a diferença no dia a dia de suas empresas. Cada feedback, cada sugestão e 
            cada palavra de incentivo nos impulsionam a evoluir constantemente.
          </p>
          
          <p className="mb-3 text-justify">
            A confiança que depositam em nossa plataforma e o comprometimento de vocês em nos ajudar a crescer são 
            fundamentais para nosso sucesso. É essa parceria genuína que nos motiva a buscar sempre a excelência 
            e a inovação.
          </p>
          
          <p className="mb-3 text-justify">
            Agradecemos imensamente por cada momento compartilhado, por cada desafio superado juntos e por toda a 
            paciência durante nosso processo de evolução. Vocês não são apenas clientes, são verdadeiros parceiros 
            nesta caminhada.
          </p>
          
          <p className="mb-0 text-justify">
            Que 2026 seja um ano de ainda mais realizações, crescimento e prosperidade para todos nós. Continuaremos 
            trabalhando com dedicação para oferecer o melhor serviço e as melhores soluções para vocês.
          </p>
        </div>
        
        <div className="carta-assinatura text-white text-center">
          <div style={{ fontSize: '32px', marginBottom: '10px' }}>🎉</div>
          <h5 className="mb-3 font-weight-bold">Feliz Ano Novo!</h5>
          <div className="decorative-line" style={{ background: 'rgba(255,255,255,0.3)' }}></div>
          <p className="mb-1" style={{ fontSize: '15px', opacity: 0.95 }}>
            Com carinho e gratidão,
          </p>
          <p className="mb-0 font-weight-bold" style={{ fontSize: '17px', letterSpacing: '0.5px' }}>
            Equipe Espião NF-e
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="carta-footer-custom border-0 justify-content-center">
        <Button variant="primary" className="btn-entendido" onClick={handleClose}>
          <i className="mdi mdi-check-circle mr-2"></i>
          Entendido
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCartaAberta;
